import type { DelegationDetails, DelegationDetailsInput } from 'generated/gql';
import { pick } from 'lodash';

export const mapDelegationDetailsToDelegationDetailsInput = (
  delegationDetails: DelegationDetails,
): DelegationDetailsInput => {
  return {
    ...pick(delegationDetails, ['voting', 'dividend', 'meeting']),
    delegateeId: delegationDetails.delegatee.id,
  };
};
